function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Graduate Hat Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.69426749,1.03204464 L18.7102675,4.46604464 L18.7406202,4.47863081 C18.7568414,4.48607521 18.7725956,4.49436216 18.7878267,4.50343562 L18.7102675,4.46604464 C18.7609604,4.48535248 18.8056684,4.51084734 18.8443914,4.5410683 C18.8476819,4.5452484 18.8521812,4.54895325 18.8566136,4.55273417 C18.9643517,4.64133323 19.022103,4.76786557 19.0310653,4.89752096 C19.0318578,4.90885729 19.0323,4.92102701 19.0323,4.9333 L19.0323,7.9813 C19.0323,8.25744237 18.8084424,8.4813 18.5323,8.4813 C18.2561576,8.4813 18.0323,8.25744237 18.0323,7.9813 L18.0323,5.6583 L15.3953,6.6623 L15.4086028,10.6018636 C15.4100885,11.2573628 15.0019896,11.8432852 14.3837107,12.0543322 C13.0801985,12.4980159 11.4415393,12.789 9.4996,12.789 C7.57353932,12.789 5.94259976,12.497262 4.64337943,12.0529529 C4.0285333,11.8420637 3.62109034,11.2613404 3.61960277,10.6096651 L3.6063,6.6503 L0.32237777,5.4005726 C-0.107037001,5.2370654 -0.107066423,4.62959343 0.322332508,4.46604464 L9.33833251,1.03204464 C9.452961,0.98838512 9.579639,0.98838512 9.69426749,1.03204464 Z M4.6073,7.0323 L4.6195987,10.6068585 C4.62012282,10.8364255 4.75997684,11.0357577 4.96739127,11.1069 C6.16562265,11.5166726 7.68804897,11.789 9.4996,11.789 C11.3277193,11.789 12.8582768,11.517212 14.0610778,11.1078081 C14.2688914,11.0368717 14.4091272,10.8355301 14.4086028,10.6046671 L14.3963,7.0423 L9.69422223,8.8335726 C9.57962071,8.87720913 9.45297929,8.87720913 9.33837777,8.8335726 L4.6073,7.0323 Z M9.5163,2.03433934 L1.90522958,4.93323196 L9.5163,7.8312804 L17.1273704,4.93323196 L9.5163,2.03433934 Z",
  id: "graduate-hat-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "graduate-hat-Icon/Global/Education",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "graduate-hat-Swatches/Midnight",
  transform: "translate(2.500000, 5.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "graduate-hat-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#graduate-hat-path-1"
})));

var SvgGraduateHat = function SvgGraduateHat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGraduateHat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/graduate-hat.8ce3673e.svg";
export { ForwardRef as ReactComponent };